// Presentation-only signal: keep durable financial identity, but allow the
// user to re-enter the original request instead of freezing a changed form.
export class ActionRecoveryError extends Error {
  constructor(readonly status?: number) {
    super('action_recovery_required');
  }
}
